import * as React from "react";
import { useTranslation } from "react-i18next";
import { hasValue, isDefined } from "@core/utils";
import { Json } from "../utils";

export const useHasTranslations = (ns?: string) => {
  const { i18n } = useTranslation(ns);
  const [hasTranslations, setHasTranslations] = React.useState(false);

  const checkTranslations = React.useCallback(() => {
    if (!i18n.isInitialized) return;

    const translations = isDefined(ns)
      ? i18n.getResourceBundle(i18n.language, ns)
      : i18n.getDataByLanguage(i18n.language);

    if (hasValue(translations)) {
      const value = Json.clean(translations);
      setHasTranslations(hasValue(value));
    } else {
      setHasTranslations(false);
    }
  }, [i18n, ns, setHasTranslations]);

  React.useEffect(() => {
    checkTranslations();

    i18n.on("languageChanged", checkTranslations);

    return () => i18n.off("languageChanged", checkTranslations);
  }, [i18n, setHasTranslations]);

  return hasTranslations;
};
